<template>
  <div
    class="description-list"
    :style="{'max-width': maxWidth}"
  >
    <div
      v-if="title"
      class="description-list__title"
    >{{title}}</div>
    <a-row v-bind="$props">
      <slot></slot>
    </a-row>
  </div>
</template>

<script>
import Row from 'ant-design-vue/es/row';

export default {
  name: 'DescriptionList',
  props: Object.assign({}, Row.props, {
    title: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: String,
      default: '',
    },
  }),
};
</script>

<style lang="less" scoped>
.description-list {
  &__title {
    padding-bottom: @padding-md;
    color: @gray-9;
    .font-size-14;
    font-weight: @font-weight-medium;
  }
}
</style>
